import $ from 'jquery';
import Lazy from 'jquery-lazy/jquery.lazy';
import {renderGallery} from './item';
import highlightWord from "./highlightWord";
import './oembed';
import {loadItemEmbedded} from "./oembed";

function isElementExistsInView(element, fullyInView, breakPoint) {
    if (!breakPoint) {
        breakPoint = 0;
    }

    let pageTop = $(window).scrollTop();
    let pageBottom = pageTop + $(window).height();
    let elementTop = $(element).offset().top;
    let elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {

        if (breakPoint && breakPoint > 0) {
            elementTop = elementTop + breakPoint;
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        } else if (breakPoint && breakPoint < 0) {
            elementTop = elementTop + breakPoint;

            return ((elementTop <= pageTop) && (elementBottom >= pageBottom));
        }

        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
}

function objectToQueryParams(object, isSubLevel) {
    let _param = $.param(object);
    if (_param.length === 0) {
        return '';
    }
    return '?' + $.param(object);
}

$.fn.loadNextItem = function (options, _pageParams) {
    let settings = $.extend({
        item_id: 0,
        wrapItems: false,
        wrapper_class: '  ',
        page_title: '',

        item_url: '',
        next_url: '',

        current_page: 0,
        next_page: 0,
        prev_page: 0,
        base_url: '',
        item_container: '.items-list',

        page_url: '',
        update_page_url: false,
        update_page_title: false,
        update_page_meta: false,
        enable_infinite_scroll: false,
        loader_class: '.list-grid-spinner',
    }, options);

    let _this = $(this);
    let _can_load_mode = true;
    let _requestData = {};
    let updatePageUrl = settings.update_page_url;
    let updatePageTitle = settings.update_page_title;
    let updatePageMeta = settings.update_page_meta;
    let enableInfiniteScroll = settings.enable_infinite_scroll;
    let isLoading = false;

    /**
     *
     * @constructor
     */

    if (settings !== false && _requestData !== false) {

        /**
         *
         * @param btn
         * @param basePageUrl
         * @param currentPage
         * @param nextPage
         * @param prevPage
         */
        function updatePageTags(element) {
            let pageTitle = element.data('page-title');
            let itemUrl = $(element).data('item-url');
            let itemId = $(element).data('item-id');
            settings.item_id = itemId;
            settings.title = pageTitle;

            updatePagingMeta(pageTitle, itemUrl, itemId);
        }

        function updatePagingMeta(_page_title, _canonical, itemId) {
            if (updatePageTitle && document.title !== _page_title) {
                document.title = _page_title;
            }
            if (updatePageUrl) {
                history.replaceState(null, _page_title, _canonical);
            }

            let dynamicPageContentElement = $('body').find($('.dynamic-page-content[data-item-id="' + itemId + '"]'));
            if (dynamicPageContentElement.length) {
                // dynamicPageContentElement.attr('data-item-id', itemId);
                // dynamicPageContentElement.attr('data-item-url', _canonical);
                // dynamicPageContentElement.attr('data-page-title', _page_title);
                //
                // dynamicPageContentElement.data('item-id', itemId);
                // dynamicPageContentElement.data('item-url', _canonical);
                // dynamicPageContentElement.data('page-title', _page_title);
            }

            if (updatePageMeta && $(document).find($('link[rel="canonical"]')).attr('href') !== _canonical) {
                $(document).find($('link[rel="canonical"]')).attr('href', _canonical);
                $(document).find($('meta[property="og:url"]')).attr('content', _canonical);
                $(document).find($('meta[property="og:title"]')).attr('content', _page_title);
            }

            if (typeof ga !== 'undefined' && typeof ga === 'function') {
                ga("send", "pageview", _canonical);
            }

        }

        function addElementToScrollEvent(element) {
            let lastScrollTop = 0;
            let st = 0;

            // $(window).unbind('scroll');
            if (enableInfiniteScroll === true) {
                bindWindowScrolling();
            }
            $(window).scroll(function () {
                st = $(this).scrollTop();
                $.each($('body').find($('.dynamic-page-content')), function (index, element) {
                    let isElementInView = isElementExistsInView($('body').find($(element)), false, ($(window).height() / 1.1));
                    if (isElementInView && $(element).data('item-id') !== settings.item_id) {
                        settings.item_id = parseInt($(element).data('item-id'), 10);
                        updatePageTags($(element));
                    }

                });
                lastScrollTop = st;
            });

        }

        function loadContent(_btn) {
            if (isLoading === true || _can_load_mode === false) {
                return false;
            }
            if (!_btn || typeof _btn === 'undefined') {
                _btn = false;
            }
            if (_btn) {
                _btn.addClass('is-loading');
            }

            let wrapperClass = settings.wrapper_class || '',
                basePageUrl = settings.base_url,

                nextPage = settings.next_page,
                currentPage = settings.current_page,
                prevPage = settings.prev_page,

                loaderClass = settings.loader_class,
                $itemsContainer = $('body').find($(settings.item_container));

            if (typeof loaderClass != 'undefined' && loaderClass.length && loaderClass != '') {
                if (typeof loaderClass !== 'object') {
                    loaderClass = $(loaderClass);
                }
                loaderClass.stop().hide('fast');
            } else {
                loaderClass = false;
            }

            $.ajax({
                type: 'get',
                url: settings.next_url,
                data: _requestData,
                beforeSend: function () {
                    isLoading = true;
                    if (loaderClass) {
                        loaderClass.stop().fadeIn('fast');
                    }
                    if (_btn) {
                        _btn.attr('disabled', 'disabled').find($('.spinner')).addClass('active')
                    }
                },
                success: function (response) {

                    if (response.statue === false) {
                        return;
                    }
                    settings.item_id = response.id;
                    settings.next_url = response.next_url;

                    currentPage = nextPage;
                    nextPage++;
                    prevPage = currentPage - 1;

                    let _pageId = 'dynamic-page-content-' + response.id;
                    let _elementAttr = ' data-page-title="' + response.title + '"' +
                        ' data-item-id="' + response.id + '"' +
                        ' data-item-url="' + response.item_url + '" ';

                    let responseData = '<div id="' + _pageId + '" class="dynamic-page-content ' + wrapperClass + ' "  ' + _elementAttr + ' >' + response.html + '</div>';

                    $itemsContainer.append(responseData);
                    renderGallery($itemsContainer.find('.gallery--' + response.id));

                    if (_btn) {
                        _btn.removeClass('is-loading');
                    }
                    isLoading = false;

                    if (settings.next_url === '') {
                        _can_load_mode = false;
                        if (_btn) {
                            _btn.stop().fadeOut('fast', function () {
                                $(this).parent().parent().remove();
                            });
                        }

                    }
                    addElementToScrollEvent('#' + _pageId);

                    $('.lazy').Lazy({
                        afterLoad: function (element) {
                            $(element).addClass('lazy--loaded');
                            $(element).parents('.has-lazy')
                                .show('fast')
                                .css('padding', 0)
                                .removeClass('spinner')
                                .removeClass('has-lazy');
                            let _root = $(element).parents('.default-item__media');
                            if (_root.length && _root.find('.default-item__image__desc').length) {
                                _root.find('.default-item__image').css({
                                    width: _root.find('.default-item__image img').css('width')
                                })
                            }
                        },
                    });
                    console.log('_pageId', _pageId)
                    highlightWord('شبكة وتر', _pageId);

                    if (loaderClass) {
                        loaderClass.stop().fadeOut('fast');
                    }

                    let element = $('body').find('#' + _pageId);
                    loadItemEmbedded();
                },

                complete: function () {
                    if (loaderClass) {
                        loaderClass.stop().fadeOut('fast');
                    }
                    isLoading = false;

                    if (_btn) {
                        _btn.removeAttr('disabled').find($('.spinner')).removeClass('active');
                        _btn.blur();
                    }
                },
                error: function () {
                    isLoading = false;
                    if (loaderClass) {
                        loaderClass.stop().fadeOut('fast');
                    }

                }
            });
        }

        function bindWindowScrolling() {

            let wrapperClass = settings.wrapper_class || '',
                basePageUrl = settings.base_url,
                nextPage = settings.next_page,
                currentPage = settings.current_page,
                prevPage = settings.prev_page,
                $itemsContainer = $('body').find($(settings.item_container));

            $(window).on('scroll', function () {

                let pageBodyOffset = $itemsContainer.offset(),
                    pageBodyHeight = $itemsContainer.height() - 500,
                    wh = $(window).scrollTop() + $(window).height(),
                    dh = pageBodyOffset.top + pageBodyHeight;

                if (wh >= dh && isLoading === false && settings.next_url != '') {
                    loadContent(false);
                }
            });
        }

        $(document).ready(function () {

            $('#load-more').on('click', function (e) {
                e.preventDefault();
                let _btn = $(this);

                if (_can_load_mode === true) {
                    loadContent(_btn);
                }

                return false;
            });

            if (enableInfiniteScroll === true && _can_load_mode === true) {
                bindWindowScrolling();
            }

        });
    }

};


export default class LoadNextItem {
    constructor(selector, options = {}, _pageParams) {
        $(selector).loadNextItem(options)
    }
}


// WEBPACK FOOTER //
// ./src/scripts/load_next_item.js